(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    function initLanguageSwitcher(switcher) {
    if (switcher.dataset.langSwitcherInitialized === 'true') return;
    switcher.dataset.langSwitcherInitialized = 'true';

    const toggle = switcher.querySelector('[data-lang-toggle]');
    const input = switcher.querySelector('[data-lang-input]');
    if (!toggle || !input) return;

    function setOpen(open) {
      switcher.toggleAttribute('data-open', open);
      toggle.setAttribute('aria-expanded', String(open));
    }

    toggle.addEventListener('click', () => {
      setOpen(!switcher.hasAttribute('data-open'));
    });

    switcher.querySelectorAll('[data-lang-option]').forEach((option) => {
      option.addEventListener('click', () => {
        if (option.dataset.value === input.value) {
          setOpen(false);
          return;
        }
        input.value = option.dataset.value;
        // Se recuerda la eleccion: desde aca en adelante gana sobre el idioma
        // del dispositivo. Lo lee el script del <head>.
        try { localStorage.setItem('lipo-idioma', option.dataset.value); } catch (e) {}
        switcher.requestSubmit();
      });
    });

    switcher.addEventListener('focusout', (event) => {
      if (switcher.contains(event.relatedTarget)) return;
      setOpen(false);
    });

    document.addEventListener('click', (event) => {
      if (!switcher.contains(event.target)) setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  }

  function initAllLanguageSwitchers() {
    document.querySelectorAll('.lang-switcher').forEach(initLanguageSwitcher);
  }

  window.addEventListener('load', initAllLanguageSwitchers);
  document.addEventListener('shopify:section:load', initAllLanguageSwitchers);
  } catch(e) { console.error(e); }
})();

})();
